import type { GlobalAttributesT, XstyledProps } from '@elliemae/ds-props-helpers';
import { PropTypes, globalAttributesPropTypes, xstyledPropTypes } from '@elliemae/ds-props-helpers';
import type { FontSizeProps, ColorProps } from '@elliemae/ds-system';
import type { WeakValidationMap } from 'react';

export declare namespace DSBackdropT {
  interface IProps {
    type?: 'fill' | 'cover';
    onClick?: React.MouseEventHandler;
  }

  export interface Props
    extends IProps,
      Omit<GlobalAttributesT<HTMLElement>, keyof IProps | 'color'>,
      XstyledProps,
      FontSizeProps,
      ColorProps {}
}

export const DSBackdropPropTypes = {
  ...globalAttributesPropTypes,
  ...xstyledPropTypes,
  /**
   * ['cover', 'fill']
   */
  type: PropTypes.oneOf(['fill', 'cover']).description('Type of backdrop'),
  /**
   * z-index of dimmer background
   */
  zIndex: PropTypes.number.description('Z-index for the backdrop'),
  /**
   * Backdrop click event
   */
  onClick: PropTypes.func.description('Backdrop click event'),
} as WeakValidationMap<unknown>;
